var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Spinner } from "@atlassiansox/microscopekit";
import SectionMessage from "@atlaskit/section-message";
import { isEmpty } from "lodash";
import { ActiveWargame } from "../../Wargame";
export var ActiveWargameForWargameExercise = function (_a) {
    var serviceId = _a.serviceId, activeWargames = _a.activeWargames, isLoading = _a.isLoading;
    var content;
    if (isLoading) {
        content = (React.createElement("span", null,
            "Loading active wargames...",
            React.createElement(SpinnerContainer, null,
                React.createElement(Spinner, null))));
    }
    else if (isEmpty(activeWargames)) {
        content = (React.createElement(SectionMessage, { title: "No wargames currently executing!" }, "Click on Execute to start a wargame"));
    }
    else {
        content = (React.createElement(ActiveWargame, { serviceId: serviceId, activeWargames: activeWargames }));
    }
    return (React.createElement("div", null,
        React.createElement("h3", null, "Active Wargame"),
        React.createElement("br", null),
        content));
};
var SpinnerContainer = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  left: 1rem;\n"], ["\n  position: relative;\n  left: 1rem;\n"])));
var templateObject_1;
